import _ from 'lodash'

class BillingService {
  constructor($log, config) {
    this.$log = $log

    if (!recurly.configured) {
      recurly.configure({
        publicKey: config.recurlyKey,
        cors: true
      })
    }
  }

  submit(form, successCallback, failureCallback) {
    this.$log.debug("Submitting form to recurly")
    recurly.token(
      form,
      (error, token) => this._onRecurlyDone(error, token, successCallback, failureCallback))
  }

  _onRecurlyDone(error, token, successCallback, failureCallback) {
    if (error) {
      this.$log.debug("Recurly signup failed")
      this.$log.debug("Fields: " + error.fields)
      this.$log.debug("code: " + error.code)
      // handle error using err.code and err.fields
      failureCallback(error)
    } else {
      // recurly.js has filled in the 'token' field, so now we can submit the
      // form to your server; alternatively, you can access token.id and do
      // any processing you wish
      // form.submit()
      this.$log.debug("Recurly Signup call succeeded: " + token)
      successCallback(token)
    }
  }
}

BillingService.$inject = ['$log', 'config']

export default BillingService
